import { createContext, useEffect, useState } from 'react'

import { FullControlUserGroups, APP_CONFIG_GROUP, UserRoles } from '../config/configuration'

const defaultRoleFlags = {
    isBusinessOwner: false,
    isSubmitter: false,
    isPMValidation: false,
    isIMIT: false,
    isRM: false,
    isDCSProcurement: false,
    isAgreementsReviewIAA: false,
    isLegal: false,
    isCMRA: false,
    isSpaceUtilization: false,
    isManpower: false,
    isATOpsec: false,
    isUnitHead: false,
    isDeputyDirector: false,
    isFMRM: false,
}

export const UserDetailsContext = createContext<{
    isSiteAdmin: boolean;
    isOwner: boolean,
    pageContextdets: Record<string, any>,
    isLoading: boolean,
    myRoles: string[],
    roles: Record<string, boolean>,
    isCustomer: boolean,
} & typeof defaultRoleFlags>({
    isSiteAdmin: false,
    isOwner: false,
    pageContextdets: {},
    isLoading: true,
    myRoles: [],
    roles: {},
    isCustomer: false,
    ...defaultRoleFlags
})

export const UserDetailsContextProvider = (props: any) => {
    const [isSiteAdmin, setIsSiteAdmin] = useState<boolean>(false)
    const [myRoles, setMyRoles] = useState<string[]>([])
    const [isOwner, setIsOwner] = useState<boolean>(false)
    const [pageContextdets, setpageContextdets] = useState<Record<string, any>>({})
    const [isLoading, setIsLoading] = useState(true)
    const [roles, setRoles] = useState<Record<string, boolean>>({})
    const [isCustomer, setIsCustomer] = useState(false)
    const [userRoleFlags, setUserRoleFlags] = useState(defaultRoleFlags)
    useEffect(() => {
        getContext()
    }, [])
    async function getContext() {
        
        const pageContext: Record<string, any> = (window as Window)._spPageContextInfo
        setpageContextdets(pageContext)
        getGroups(pageContext)
    }  

    const getGroups = async (pageContext: Record<string, any>) => {
        try {
            const groups: any = await sp.web.getUserById(pageContext.userId).groups()
            const roles: Array<string> = Array.from(new Set(groups?.map((v: any) => v.Title)))
            setMyRoles(roles)
            getLoginRole(roles, pageContext)
        } catch (error) {
            setIsLoading(false)
            console.log('Error fetching user groups:', error)
        }
    }
    const getLoginRole = (roles: string[], pageContext: Record<string, any>) => {
        const roleChecks = [
            { key: 'isSiteAdmin', condition: pageContext?.isSiteAdmin || roles?.some((r: string) => APP_CONFIG_GROUP?.includes(r)) },
            { key: 'isOwner', condition: roles?.some((r: string) => FullControlUserGroups?.includes(r)) }
        ]
        const roleState: Record<string, boolean> = {}
        roleChecks?.forEach((role) => {
            roleState[role.key] = role.condition
        })
        roleState.isCustomer = !roleState.isSiteAdmin && !roleState.isOwner
        setRoles(roleState)
        setIsCustomer(roleState.isCustomer)
        setIsSiteAdmin(roleState.isSiteAdmin)
        setIsOwner(roleState.isOwner)
        const otherRoles = [
            UserRoles.BUSINESS_OWNERS,
            UserRoles.PM_VALIDATION,
            UserRoles.IM_IT,
            UserRoles.RM,
            UserRoles.DCS_PROCUREMENT,
            UserRoles.AGREEMENTS_REVIEW_IAA,
            UserRoles.LEGAL,
            UserRoles.CMRA,
            UserRoles.SPACE_UTILIZATION,
            UserRoles.MANPOWER,
            UserRoles.AT_OPSEC,
            UserRoles.UNIT_HEAD,
            UserRoles.DEPUTY_DIRECTOR,
            UserRoles.FM_RM,
        ]
        const isInSubmitter = roles?.some(r => r === UserRoles.SUBMITTER) ?? false
        const isInOtherRole = roles?.some(r => otherRoles.includes(r as any)) ?? false
        setUserRoleFlags({
            isBusinessOwner: roles?.some(r => r === UserRoles.BUSINESS_OWNERS) ?? false,
            isSubmitter: isInSubmitter && !isInOtherRole,
            isPMValidation: roles?.some(r => r === UserRoles.PM_VALIDATION) ?? false,
            isIMIT: roles?.some(r => r === UserRoles.IM_IT) ?? false,
            isRM: roles?.some(r => r === UserRoles.RM) ?? false,
            isDCSProcurement: roles?.some(r => r === UserRoles.DCS_PROCUREMENT) ?? false,
            isAgreementsReviewIAA: roles?.some(r => r === UserRoles.AGREEMENTS_REVIEW_IAA) ?? false,
            isLegal: roles?.some(r => r === UserRoles.LEGAL) ?? false,
            isCMRA: roles?.some(r => r === UserRoles.CMRA) ?? false,
            isSpaceUtilization: roles?.some(r => r === UserRoles.SPACE_UTILIZATION) ?? false,
            isManpower: roles?.some(r => r === UserRoles.MANPOWER) ?? false,
            isATOpsec: roles?.some(r => r === UserRoles.AT_OPSEC) ?? false,
            isUnitHead: roles?.some(r => r === UserRoles.UNIT_HEAD) ?? false,
            isDeputyDirector: roles?.some(r => r === UserRoles.DEPUTY_DIRECTOR) ?? false,
            isFMRM: roles?.some(r => r === UserRoles.FM_RM) ?? false,
        })
        setIsLoading(false)
    }

      useEffect(() => {
        getContext()
    }, [])

    return (
        <UserDetailsContext.Provider value={{ isSiteAdmin, isOwner, pageContextdets, isLoading, myRoles, roles, isCustomer, ...userRoleFlags }}>
            {props.children}
        </UserDetailsContext.Provider>
    )
}